import { memo } from 'react'

import type { IIconsProps } from './icons.types'

const IconTooltipPointUp = ({
  width = 12,
  height = 6,
  ...props
}: IIconsProps) => {
  return (
    <svg
      width={width}
      height={height}
      fill='none'
      viewBox='0 0 12 6'
      {...props}
    >
      <path
        d='M6 0H12L7.41421 4.58579C6.63317 5.36683 5.36684 5.36684 4.58579 4.58579L0 0H6Z'
        fill='currentColor'
      />
    </svg>
  )
}

export default memo(IconTooltipPointUp)
